import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_beauty_skincare: FaireCategoryEntity = {
  token: "cat_beauty-skincare",
  type: "category",
  name: "Skincare",
  level: 2,
  parentToken: "cat_beauty-wellness",
  href: "/category/skincare",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
